import axios from '@/axios'

let accessToken = localStorage.accessToken
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
axios.defaults.headers.post['Content-Type'] = 'application/json'

export default {
	namespaced: true,
	actions: {
	 async getSubscriptionStatus( {commit, dispatch, rootState} ) {
		let organization_id = rootState.user.current_organization
			await axios.get(`/organization/${organization_id}/subscription`)
			.then((res) => {
				let type = res.data.data === 'new' ? 't' : 'n'
				commit('SET_SUBS_STATUS', type)
				dispatch('getPackage', type)
			})
			.catch((err) => { console.log(err) })
	 },
	 async getPackage({commit}, type){
		 await axios.get(`/subscription?type=${type}`)
		 .then((res) => {
			commit('SET_PACKAGE', res.data.data)
		 })
		 .catch((err) => { console.log(err) })
	 },
	 async subscribeTrialPlan({rootState,commit}, payload) {
		 return new Promise((resolve, reject) => {
				axios.post('/subscription/subscribe', payload)
				.then(() => {
					let current_step = 6 
					axios.patch(`/user/${rootState.user.id}`, { onboard_step: current_step })
					.then(() => {
						let payload = {
							onboard_step: current_step,
							...rootState.user
						}
						commit('user/UPDATE_USER_INFO', payload,{root:true})
						resolve(payload)
					})
					.catch((err) => { reject(err) })
				})
				.catch((err) => { reject(err) })
		 })
	 },
	 async subscribePlan({commit}, payload){
		return new Promise((resolve,reject) => {
			axios.post('/subscription/subscribe', payload)
			.then((res) => {
				resolve(res)
			})
			.catch((err) => { reject(err) })
		})
	 },
	 getSubscriptionSummary({rootState,commit}) {
		 return new Promise((resolve,reject) => {
			 axios.get(`/organization/${rootState.user.current_organization}/report`)
			 .then((res) => {
				commit('SET_SUBS_SUMMARY',res.data.data)
				resolve(res.data.data)
			 })
			 .catch((err)=> {reject(err)})
		 })
	 },
	 async getPackageDetails({rootState, commit}){
		return new Promise((resolve,reject) => {
			axios.get(`/organization/${rootState.user.current_organization}/subscription/package`)
			.then(async(res) => {
			 await commit('SET_PACKAGE_DETAILS',res.data.data)
			 resolve(res.data.data)
			})
			.catch((err)=> {reject(err)})
		})
	 },
	 async checkPreviousPackage({}){
		 return new Promise((resolve,reject) => {
			 axios.get(`/subscription/organization/previous`)
			 .then((res) => {
				 resolve(res.data.data)
			 })
			 .catch((err)=> {reject(err)} )
		 })
	 }
	},
	getters: {
		status: state => state.status,
	},
	mutations: {
		SET_PACKAGE (state, packages){
			state.packages = packages
		},
		SET_SUBS_STATUS (state, status){
			state.status = status
		},
		SET_SUBS_SUMMARY (state, subscription_summary){
			state.subscription_summary = subscription_summary
		},
		SET_PACKAGE_DETAILS (state, package_summary){
			state.package_summary = package_summary
		},
	},
	state: {
		status: null,
		packages:[],
		subscription_summary: null,
		package_summary: [],
		current_package: null
	  }
}